export const REPORT_MODE_NORMAL = "normal";
export const REPORT_MODE_BINARY = "binary";

export const VALUE_KEYS_BY_MODE = {
  [REPORT_MODE_NORMAL]: 'distribution',
  [REPORT_MODE_BINARY]: 'per_response',
}